//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025, 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/**
 * Normalize provider names to match SelectItem values
 * Handles various formats from API responses
 */
export const normalizeProvider = (val: string): string => {
  const normalized = val.toLowerCase().trim();
  const map: Record<string, string> = {
    openai: 'openai',
    'ibm watsonx': 'ibm-watson-x',
    'ibm watson x': 'ibm-watson-x',
    'ibm-watson-x': 'ibm-watson-x',
    gemini: 'gemini',
    claude: 'claude',
    'azure openai': 'azure-openai',
    'azure-openai': 'azure-openai',
    ollama: 'ollama',
  };
  return map[normalized] || normalized;
};
